import {CxEvent} from '@spartacus/core';
import {AdobeTrackingProductData} from '@app/services/analytics/models/adobe-tracking-data';

export class EddlFormErrorEvent extends CxEvent {
  static readonly type = 'EddlFormErrorEvent';
  name?: string;
  errorDescription?: string;
  products?: AdobeTrackingProductData[];
}
